import React from 'react';
import { useState, useEffect } from 'react';
import { Button, Space, Tabs, Typography } from 'antd';
import type { TabsProps } from 'antd';
import { Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import SweetAlert from "sweetalert2"
import { Chip } from '@mui/material';
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box } from '@mui/material';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Utilisateur from '../../../../Models/Utilisateur';
import 'react-toastify/dist/ReactToastify.css';
import Data from '../../../../Data/Data.json';
import Tab1 from './Tab1';


const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;


//client Physique
const ImputInteret = () => {
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  // USER TOKEN
  const authHeader = useAuthHeader();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useState({});
  const [start, setstart] = useState(false);
 

  useEffect(
    () => {
      form.setFieldValue('Mois', user.datjour && user.datjour !== '' ? user.datjour.substring(5, 7) : '');
      if (start === false) {

        setstart(true)
      }
      forceUpdate({});
    },
    []);


  const onFinish = async (values: any) =>
   {
    
    let DatImput = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
    let Libellciontaxe: string = "";
    let LibellTax: string = "";
    let Option:string= form.getFieldValue("OptionImput")?form.getFieldValue("OptionImput"):"1";
    let LibellAfiche: string = "";
    
   
    switch (form.getFieldValue('TypeImputation')) {
      case '1':
        { 
          if(Option=='1'||Option=='3' || Option=='5')
              {
                Libellciontaxe = form.getFieldValue('LibIndebTax');
                LibellTax = form.getFieldValue('LibIndebTax');
                LibellAfiche=Libellciontaxe;
             
              }
            else if(Option =='2'||Option=='4' ||Option=='6')
              {
                Libellciontaxe = form.getFieldValue('LibIndebTax');
                LibellTax = form.getFieldValue('LibTax');
                LibellAfiche=Libellciontaxe +" et "+ LibellTax;
               
              }
              break;
          }
      case '2':
        {
          Libellciontaxe = form.getFieldValue('libgcptINTTaxC');
          LibellTax = form.getFieldValue('libgcptINTTaxC');
          LibellAfiche=LibellTax;
          break;
        }
    }
    

    SweetAlert.fire({
      title: "Imputation Des intérets",
      text: "Voulez-vous Imputer le calcul pour :" + LibellAfiche + "? ",
      showCancelButton: true,
      color: "#116599",
      confirmButtonText: "Yes",
      confirmButtonColor: "#116599",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then(async (res) => {
      if (res.isConfirmed) {
        setLoading(true);
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ImputationEOM,
          headers: {
            'Authorization': authHeader(),
            'Content-Type': 'application/json',
            'CypherCodu': Crypter.encrypt(user.coduti),
            'CypherAgence': Crypter.encrypt(user.codage),
            'CypherdatImput': Crypter.encrypt(DatImput),
            'CypherLibellciontaxe': Crypter.encrypt(Libellciontaxe),
            'CypherTaxe': Crypter.encrypt(LibellTax),
            'CypherTypeImput': Crypter.encrypt(values.TypeImputation),
            'CypherOption': Crypter.encrypt(form.getFieldValue('TypeImputation'))
          },
        };

      await  axios.request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              if (res.StatutCode == 200) {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                form.setFieldsValue({'libgcptINTTaxC':'','LibIndebTax':'','LibTax':''})
              }
              else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
          });
      }
    })
  };


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />
          Imputation Des Interets et Commissions
        </span>
      ),
      children: <><Tab1 form={form} /></>
    }
  ];


  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + "");
    })
    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
  };


  return (
    <div className='tab'>
      <Box className='formTitle'>
        <Breadcrumbs aria-label="breadcrumb">
          <StyledBreadcrumb component="a" href="/jjh" label="Home" icon={<HomeIcon fontSize="small" />} />
          <StyledBreadcrumb component="a" href="#" label="Gestion" />
          <StyledBreadcrumb label="Imputation Des Interets et Commissions" deleteIcon={<ExpandMoreIcon />} />
        </Breadcrumbs>
      </Box>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinishFailed={onFinishFailed} onFinish={onFinish} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='clientP'><div > <Tabs size='large' type="card" items={items} /></div>
            <div className='bG'>
              <legend><Typography color={"#116599"}>Actions</Typography></legend>
              <Form.Item shouldUpdate className='bouttong'>
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Button size='large' className='bt_add' type="ghost" htmlType="submit" block>
                    Enregistrer
                  </Button>
                </Space>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}

export default ImputInteret;

